/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.8.2.0 (NJsonSchema v10.2.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class SurveyClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
  }

  /**
   * Get surveys list (Auth roles: Administrator,Pulinet)
   * @param query (optional) Serialization of QueryInfo data Type
   * @return Return surveys list
   */
  list(query: string | undefined, cancelToken?: CancelToken | undefined): Promise<SurveyListItemDTOQueryResult> {
    let url_ = this.baseUrl + '/survey/list?';
    if (query === null) throw new Error("The parameter 'query' cannot be null.");
    else if (query !== undefined) url_ += 'query=' + encodeURIComponent('' + query) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processList(_response);
      });
  }

  protected processList(response: AxiosResponse): Promise<SurveyListItemDTOQueryResult> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = SurveyListItemDTOQueryResult.fromJS(resultData200);
      return result200;
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException('A generic error occurred', status, _responseText, _headers);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException('Unauthorized', status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException('Forbidden', status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException('An unexpected server error occurred.', status, _responseText, _headers);
    }
    return Promise.resolve<SurveyListItemDTOQueryResult>(<any>null);
  }

  /**
   * Create a new survey (Auth roles: Administrator,Pulinet)
   * @param body (optional)
   * @return Survey created, return surveyId
   */
  surveyPost(body: SurveyDetailDTO | undefined, cancelToken?: CancelToken | undefined): Promise<number> {
    let url_ = this.baseUrl + '/survey';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json-patch+json',
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSurveyPost(_response);
      });
  }

  protected processSurveyPost(response: AxiosResponse): Promise<number> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;
      return result200;
    } else if (status === 400) {
      const _responseText = response.data;
      return throwException('Invalid field values: some values are null or empty', status, _responseText, _headers);
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException('Association User not found by id', status, _responseText, _headers);
    } else if (status === 409) {
      const _responseText = response.data;
      return throwException('An association already exist', status, _responseText, _headers);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException('A generic error occurred', status, _responseText, _headers);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException('Unauthorized', status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException('Forbidden', status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException('An unexpected server error occurred.', status, _responseText, _headers);
    }
    return Promise.resolve<number>(<any>null);
  }

  /**
   * Update a survey (Auth roles: Administrator,Pulinet)
   * @param body (optional)
   * @return Survey updated
   */
  surveyPut(body: SurveyDetailDTO | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + '/survey';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json-patch+json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSurveyPut(_response);
      });
  }

  protected processSurveyPut(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status === 400) {
      const _responseText = response.data;
      return throwException('Invalid field values: some values are null or empty', status, _responseText, _headers);
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException('Survey not found', status, _responseText, _headers);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException('A generic error occurred', status, _responseText, _headers);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException('Unauthorized', status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException('Forbidden', status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException('An unexpected server error occurred.', status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * Answer to a survey (Auth roles: Customer)
   * @param body (optional)
   * @return Survey answered
   */
  answer(body: SurveyAnswerDTO | undefined, cancelToken?: CancelToken | undefined): Promise<void> {
    let url_ = this.baseUrl + '/survey/answer';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json-patch+json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processAnswer(_response);
      });
  }

  protected processAnswer(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status === 400) {
      const _responseText = response.data;
      return throwException('Invalid field values: some values are null or empty', status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException('Is not customer survey', status, _responseText, _headers);
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException('Survey not found', status, _responseText, _headers);
    } else if (status === 409) {
      const _responseText = response.data;
      return throwException('User has already answered to this survey', status, _responseText, _headers);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException('A generic error occurred', status, _responseText, _headers);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException('Unauthorized', status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException('An unexpected server error occurred.', status, _responseText, _headers);
    }
    return Promise.resolve<void>(<any>null);
  }

  /**
   * Gets survey detail by id (Auth roles: Administrator,Pulinet)
   * @return Return survey details
   */
  details(surveyid: number, cancelToken?: CancelToken | undefined): Promise<SurveyDetailDTO> {
    let url_ = this.baseUrl + '/survey/{surveyid}/details';
    if (surveyid === undefined || surveyid === null) throw new Error("The parameter 'surveyid' must be defined.");
    url_ = url_.replace('{surveyid}', encodeURIComponent('' + surveyid));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDetails(_response);
      });
  }

  protected processDetails(response: AxiosResponse): Promise<SurveyDetailDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = SurveyDetailDTO.fromJS(resultData200);
      return result200;
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException('Survey not found', status, _responseText, _headers);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException('A generic error occurred', status, _responseText, _headers);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException('Unauthorized', status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException('Forbidden', status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException('An unexpected server error occurred.', status, _responseText, _headers);
    }
    return Promise.resolve<SurveyDetailDTO>(<any>null);
  }

  /**
   * Get survey detail from customer (Auth roles: Customer)
   * @return Return survey detail
   */
  myDetail(surveyid: number, cancelToken?: CancelToken | undefined): Promise<SurveyCustomerDetailDTO> {
    let url_ = this.baseUrl + '/survey/{surveyid}/my-detail';
    if (surveyid === undefined || surveyid === null) throw new Error("The parameter 'surveyid' must be defined.");
    url_ = url_.replace('{surveyid}', encodeURIComponent('' + surveyid));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processMyDetail(_response);
      });
  }

  protected processMyDetail(response: AxiosResponse): Promise<SurveyCustomerDetailDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = SurveyCustomerDetailDTO.fromJS(resultData200);
      return result200;
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException('Is not customer survey', status, _responseText, _headers);
    } else if (status === 404) {
      const _responseText = response.data;
      return throwException('Survey not found', status, _responseText, _headers);
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException('A generic error occurred', status, _responseText, _headers);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException('Unauthorized', status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException('An unexpected server error occurred.', status, _responseText, _headers);
    }
    return Promise.resolve<SurveyCustomerDetailDTO>(<any>null);
  }

  /**
   * Get survey answer statistics (Auth roles: Administrator,Pulinet)
   * @return Return survey statistics
   */
  statistics(surveyid: number, cancelToken?: CancelToken | undefined): Promise<SurveyStatisticsDTO> {
    let url_ = this.baseUrl + '/survey/{surveyid}/statistics';
    if (surveyid === undefined || surveyid === null) throw new Error("The parameter 'surveyid' must be defined.");
    url_ = url_.replace('{surveyid}', encodeURIComponent('' + surveyid));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processStatistics(_response);
      });
  }

  protected processStatistics(response: AxiosResponse): Promise<SurveyStatisticsDTO> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = SurveyStatisticsDTO.fromJS(resultData200);
      return result200;
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException('A generic error occurred', status, _responseText, _headers);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException('Unauthorized', status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException('Forbidden', status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException('An unexpected server error occurred.', status, _responseText, _headers);
    }
    return Promise.resolve<SurveyStatisticsDTO>(<any>null);
  }

  /**
   * Get survey answers list (Auth roles: Administrator,Pulinet)
   * @return Return survey answers list
   */
  answersList(surveyid: number, cancelToken?: CancelToken | undefined): Promise<SurveyAnswerListItemDTO[]> {
    let url_ = this.baseUrl + '/survey/{surveyid}/answers-list';
    if (surveyid === undefined || surveyid === null) throw new Error("The parameter 'surveyid' must be defined.");
    url_ = url_.replace('{surveyid}', encodeURIComponent('' + surveyid));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <AxiosRequestConfig>{
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json',
      },
      cancelToken,
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processAnswersList(_response);
      });
  }

  protected processAnswersList(response: AxiosResponse): Promise<SurveyAnswerListItemDTO[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(SurveyAnswerListItemDTO.fromJS(item));
      }
      return result200;
    } else if (status === 500) {
      const _responseText = response.data;
      return throwException('A generic error occurred', status, _responseText, _headers);
    } else if (status === 401) {
      const _responseText = response.data;
      return throwException('Unauthorized', status, _responseText, _headers);
    } else if (status === 403) {
      const _responseText = response.data;
      return throwException('Forbidden', status, _responseText, _headers);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException('An unexpected server error occurred.', status, _responseText, _headers);
    }
    return Promise.resolve<SurveyAnswerListItemDTO[]>(<any>null);
  }
}

/** 0 = CUSTOMER_PERMISSION_SITE 1 = CUSTOMER_PERMISSION_PLANNING 2 = CUSTOMER_PERMISSION_CALENDAR 3 = CUSTOMER_PERMISSION_EMPLOYEE 4 = CUSTOMER_PERMISSION_EMPLOYEE_STAMPINGS 5 = CUSTOMER_PERMISSION_DOCUMENTS 6 = CUSTOMER_PERMISSION_COMMUNICATIONS 7 = CUSTOMER_PERMISSION_CONTACTS 8 = CUSTOMER_PERMISSION_QUALITY_CONTROLS 9 = CUSTOMER_PERMISSION_QUALITY_REPORTS 10 = CUSTOMER_PERMISSION_QUALITY_STATS 11 = CUSTOMER_PERMISSION_KIOSKS 12 = CUSTOMER_PERMISSION_REAL_ESTATE_REGISTRY 13 = CUSTOMER_PERMISSION_BILLING 14 = CUSTOMER_PERMISSION_COMMUNICATIONS_ALL_TICKETS 15 = CUSTOMER_PERMISSION_SITE_EQUIPMENTS 16 = CUSTOMER_PERMISSION_ECONOMICS */
export enum CustomerRoleClaim {
  CUSTOMER_PERMISSION_SITE = 0,
  CUSTOMER_PERMISSION_PLANNING = 1,
  CUSTOMER_PERMISSION_CALENDAR = 2,
  CUSTOMER_PERMISSION_EMPLOYEE = 3,
  CUSTOMER_PERMISSION_EMPLOYEE_STAMPINGS = 4,
  CUSTOMER_PERMISSION_DOCUMENTS = 5,
  CUSTOMER_PERMISSION_COMMUNICATIONS = 6,
  CUSTOMER_PERMISSION_CONTACTS = 7,
  CUSTOMER_PERMISSION_QUALITY_CONTROLS = 8,
  CUSTOMER_PERMISSION_QUALITY_REPORTS = 9,
  CUSTOMER_PERMISSION_QUALITY_STATS = 10,
  CUSTOMER_PERMISSION_KIOSKS = 11,
  CUSTOMER_PERMISSION_REAL_ESTATE_REGISTRY = 12,
  CUSTOMER_PERMISSION_BILLING = 13,
  CUSTOMER_PERMISSION_COMMUNICATIONS_ALL_TICKETS = 14,
  CUSTOMER_PERMISSION_SITE_EQUIPMENTS = 15,
  CUSTOMER_PERMISSION_ECONOMICS = 16,
}

export class CustomerUserListItemDTO implements ICustomerUserListItemDTO {
  userId?: string | undefined;
  username?: string | undefined;
  firstName?: string | undefined;
  surname?: string | undefined;
  email?: string | undefined;
  enabled?: boolean;
  activationLink?: string | undefined;
  ragioneSociale?: string | undefined;
  customerSubRoles?: CustomerRoleClaim[] | undefined;

  constructor(data?: ICustomerUserListItemDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userId = _data['userId'];
      this.username = _data['username'];
      this.firstName = _data['firstName'];
      this.surname = _data['surname'];
      this.email = _data['email'];
      this.enabled = _data['enabled'];
      this.activationLink = _data['activationLink'];
      this.ragioneSociale = _data['ragioneSociale'];
      if (Array.isArray(_data['customerSubRoles'])) {
        this.customerSubRoles = [] as any;
        for (let item of _data['customerSubRoles']) this.customerSubRoles!.push(item);
      }
    }
  }

  static fromJS(data: any): CustomerUserListItemDTO {
    data = typeof data === 'object' ? data : {};
    let result = new CustomerUserListItemDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['userId'] = this.userId;
    data['username'] = this.username;
    data['firstName'] = this.firstName;
    data['surname'] = this.surname;
    data['email'] = this.email;
    data['enabled'] = this.enabled;
    data['activationLink'] = this.activationLink;
    data['ragioneSociale'] = this.ragioneSociale;
    if (Array.isArray(this.customerSubRoles)) {
      data['customerSubRoles'] = [];
      for (let item of this.customerSubRoles) data['customerSubRoles'].push(item);
    }
    return data;
  }
}

export interface ICustomerUserListItemDTO {
  userId?: string | undefined;
  username?: string | undefined;
  firstName?: string | undefined;
  surname?: string | undefined;
  email?: string | undefined;
  enabled?: boolean;
  activationLink?: string | undefined;
  ragioneSociale?: string | undefined;
  customerSubRoles?: CustomerRoleClaim[] | undefined;
}

export class SurveyAnswerDTO implements ISurveyAnswerDTO {
  surveyId?: number;
  surveyAnswerId?: number;
  score?: number;
  comment?: string | undefined;

  constructor(data?: ISurveyAnswerDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.surveyId = _data['surveyId'];
      this.surveyAnswerId = _data['surveyAnswerId'];
      this.score = _data['score'];
      this.comment = _data['comment'];
    }
  }

  static fromJS(data: any): SurveyAnswerDTO {
    data = typeof data === 'object' ? data : {};
    let result = new SurveyAnswerDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['surveyId'] = this.surveyId;
    data['surveyAnswerId'] = this.surveyAnswerId;
    data['score'] = this.score;
    data['comment'] = this.comment;
    return data;
  }
}

export interface ISurveyAnswerDTO {
  surveyId?: number;
  surveyAnswerId?: number;
  score?: number;
  comment?: string | undefined;
}

export class SurveyAnswerListItemDTO implements ISurveyAnswerListItemDTO {
  surveyAnswerId?: number;
  score?: number;
  comment?: string | undefined;
  timeStamp?: Date;
  username?: string | undefined;
  businessName?: string | undefined;

  constructor(data?: ISurveyAnswerListItemDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.surveyAnswerId = _data['surveyAnswerId'];
      this.score = _data['score'];
      this.comment = _data['comment'];
      this.timeStamp = _data['timeStamp'] ? new Date(_data['timeStamp'].toString()) : <any>undefined;
      this.username = _data['username'];
      this.businessName = _data['businessName'];
    }
  }

  static fromJS(data: any): SurveyAnswerListItemDTO {
    data = typeof data === 'object' ? data : {};
    let result = new SurveyAnswerListItemDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['surveyAnswerId'] = this.surveyAnswerId;
    data['score'] = this.score;
    data['comment'] = this.comment;
    data['timeStamp'] = this.timeStamp ? this.timeStamp.toISOString() : <any>undefined;
    data['username'] = this.username;
    data['businessName'] = this.businessName;
    return data;
  }
}

export interface ISurveyAnswerListItemDTO {
  surveyAnswerId?: number;
  score?: number;
  comment?: string | undefined;
  timeStamp?: Date;
  username?: string | undefined;
  businessName?: string | undefined;
}

export class SurveyCustomerDetailDTO implements ISurveyCustomerDetailDTO {
  surveyId?: number;
  surveyAnswerId?: number;
  title?: string | undefined;
  referenceDate?: Date;
  question?: string | undefined;
  hasAlreadyAnswered?: boolean;

  constructor(data?: ISurveyCustomerDetailDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.surveyId = _data['surveyId'];
      this.surveyAnswerId = _data['surveyAnswerId'];
      this.title = _data['title'];
      this.referenceDate = _data['referenceDate'] ? new Date(_data['referenceDate'].toString()) : <any>undefined;
      this.question = _data['question'];
      this.hasAlreadyAnswered = _data['hasAlreadyAnswered'];
    }
  }

  static fromJS(data: any): SurveyCustomerDetailDTO {
    data = typeof data === 'object' ? data : {};
    let result = new SurveyCustomerDetailDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['surveyId'] = this.surveyId;
    data['surveyAnswerId'] = this.surveyAnswerId;
    data['title'] = this.title;
    data['referenceDate'] = this.referenceDate ? this.referenceDate.toISOString() : <any>undefined;
    data['question'] = this.question;
    data['hasAlreadyAnswered'] = this.hasAlreadyAnswered;
    return data;
  }
}

export interface ISurveyCustomerDetailDTO {
  surveyId?: number;
  surveyAnswerId?: number;
  title?: string | undefined;
  referenceDate?: Date;
  question?: string | undefined;
  hasAlreadyAnswered?: boolean;
}

export class SurveyDTO implements ISurveyDTO {
  surveyId?: number;
  title?: string | undefined;
  state?: SurveyState;
  referenceDate?: Date | undefined;
  publishDate?: Date | undefined;
  question?: string | undefined;

  constructor(data?: ISurveyDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.surveyId = _data['surveyId'];
      this.title = _data['title'];
      this.state = _data['state'];
      this.referenceDate = _data['referenceDate'] ? new Date(_data['referenceDate'].toString()) : <any>undefined;
      this.publishDate = _data['publishDate'] ? new Date(_data['publishDate'].toString()) : <any>undefined;
      this.question = _data['question'];
    }
  }

  static fromJS(data: any): SurveyDTO {
    data = typeof data === 'object' ? data : {};
    let result = new SurveyDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['surveyId'] = this.surveyId;
    data['title'] = this.title;
    data['state'] = this.state;
    data['referenceDate'] = this.referenceDate ? this.referenceDate.toISOString() : <any>undefined;
    data['publishDate'] = this.publishDate ? this.publishDate.toISOString() : <any>undefined;
    data['question'] = this.question;
    return data;
  }
}

export interface ISurveyDTO {
  surveyId?: number;
  title?: string | undefined;
  state?: SurveyState;
  referenceDate?: Date | undefined;
  publishDate?: Date | undefined;
  question?: string | undefined;
}

export class SurveyDetailDTO implements ISurveyDetailDTO {
  survey?: SurveyDTO;
  users?: CustomerUserListItemDTO[] | undefined;

  constructor(data?: ISurveyDetailDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.survey = _data['survey'] ? SurveyDTO.fromJS(_data['survey']) : <any>undefined;
      if (Array.isArray(_data['users'])) {
        this.users = [] as any;
        for (let item of _data['users']) this.users!.push(CustomerUserListItemDTO.fromJS(item));
      }
    }
  }

  static fromJS(data: any): SurveyDetailDTO {
    data = typeof data === 'object' ? data : {};
    let result = new SurveyDetailDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['survey'] = this.survey ? this.survey.toJSON() : <any>undefined;
    if (Array.isArray(this.users)) {
      data['users'] = [];
      for (let item of this.users) data['users'].push(item.toJSON());
    }
    return data;
  }
}

export interface ISurveyDetailDTO {
  survey?: SurveyDTO;
  users?: CustomerUserListItemDTO[] | undefined;
}

export class SurveyListItemDTO implements ISurveyListItemDTO {
  surveyId?: number;
  title?: string | undefined;
  state?: SurveyState;
  referenceDate?: Date;
  answersCount?: number;

  constructor(data?: ISurveyListItemDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.surveyId = _data['surveyId'];
      this.title = _data['title'];
      this.state = _data['state'];
      this.referenceDate = _data['referenceDate'] ? new Date(_data['referenceDate'].toString()) : <any>undefined;
      this.answersCount = _data['answersCount'];
    }
  }

  static fromJS(data: any): SurveyListItemDTO {
    data = typeof data === 'object' ? data : {};
    let result = new SurveyListItemDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['surveyId'] = this.surveyId;
    data['title'] = this.title;
    data['state'] = this.state;
    data['referenceDate'] = this.referenceDate ? this.referenceDate.toISOString() : <any>undefined;
    data['answersCount'] = this.answersCount;
    return data;
  }
}

export interface ISurveyListItemDTO {
  surveyId?: number;
  title?: string | undefined;
  state?: SurveyState;
  referenceDate?: Date;
  answersCount?: number;
}

export class SurveyListItemDTOQueryResult implements ISurveyListItemDTOQueryResult {
  data?: SurveyListItemDTO[] | undefined;
  total?: number;

  constructor(data?: ISurveyListItemDTOQueryResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['data'])) {
        this.data = [] as any;
        for (let item of _data['data']) this.data!.push(SurveyListItemDTO.fromJS(item));
      }
      this.total = _data['total'];
    }
  }

  static fromJS(data: any): SurveyListItemDTOQueryResult {
    data = typeof data === 'object' ? data : {};
    let result = new SurveyListItemDTOQueryResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.data)) {
      data['data'] = [];
      for (let item of this.data) data['data'].push(item.toJSON());
    }
    data['total'] = this.total;
    return data;
  }
}

export interface ISurveyListItemDTOQueryResult {
  data?: SurveyListItemDTO[] | undefined;
  total?: number;
}

/** 0 = DRAFT 1 = SENT */
export enum SurveyState {
  DRAFT = 0,
  SENT = 1,
}

export class SurveyStatisticsDTO implements ISurveyStatisticsDTO {
  surveyId?: number;
  votesAverage?: number;
  votesCount?: number;

  constructor(data?: ISurveyStatisticsDTO) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.surveyId = _data['surveyId'];
      this.votesAverage = _data['votesAverage'];
      this.votesCount = _data['votesCount'];
    }
  }

  static fromJS(data: any): SurveyStatisticsDTO {
    data = typeof data === 'object' ? data : {};
    let result = new SurveyStatisticsDTO();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['surveyId'] = this.surveyId;
    data['votesAverage'] = this.votesAverage;
    data['votesCount'] = this.votesCount;
    return data;
  }
}

export interface ISurveyStatisticsDTO {
  surveyId?: number;
  votesAverage?: number;
  votesCount?: number;
}

export class ApiException extends Error {
  message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): any {
  if (result !== null && result !== undefined) throw result;
  else throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
  return obj && obj.isAxiosError === true;
}
